import React, { useState } from 'react';
import IconItem from 'components/common/icon/IconItem';
import axios from 'helpers/api';
import { useEffect } from 'react'
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import moment from 'moment';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import InsuranceModal from './InsuranceModal';
import { Col } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';

const InsuranceTable = (props) => {

    function handleEditInput(editValue) {
        props.onCallEditParent(editValue);
    }

    const columns = [
        {
            accessorKey: 'insurance',
            header: 'Insurance Name',
            meta: {
                headerProps: { className: 'pe-1 col-lg-8 text-start text-900' }
            }
        },
        // {
        //     accessorKey: 'updated_by',
        //     header: 'Updated By',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'updatedate',
        //     header: 'Updated Date',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        {
            accessorKey: 'Action',
            header: '',
            meta: {
                headerProps: {
                    className: 'text-900'
                },
                cellProps: {
                    className: 'align-items-center'
                }
            },
            enableSorting: false,
            cell: ({ row: { original } }) => {
                return <IconItem
                    tag="button"
                    icon={['far', 'edit']}
                    size="sm"
                    onClick={() => handleEditInput({
                        insurance: original.insurance,
                        is_active: original.is_active,
                        insurance_id: original.insurance_id
                    })}
                    className="btn rounded-3 me-2 fs-11 align-items-center"
                />
            }
        }
    ];

    const [insuranceinfo, setInsuranceInfo] = useState([]);
    const [error, setError] = useState(true);

    // const [showModal, setShowModal] = useState(false);

    // const handleEditInsuranceModal = (insuranceValue, isActive, insuranceId) => {
    //     localStorage.setItem("insuranceValue", insuranceValue);
    //     localStorage.setItem("insuranceId", insuranceId);
    //     localStorage.setItem("isActive", isActive);
    //     setShowModal(true);
    // };

    useEffect(() => {

        async function fetchInsuranceInfo() {

            let tokenStr = localStorage.getItem("accessToken");

            const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/patients/list-patient-insurance", { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            const results = []
            const insuranceInfoData = data.data

            if (data.status) {
                insuranceInfoData.forEach((value) => {
                    let active_sts = value.is_active ? "active" : "inactive";
                    if (props.active_status == active_sts) {
                        results.push({
                            insurance: value.name,
                            insurance_id: value.id,
                            is_active: value.is_active// ? 1 : 0
                            // updated_by: value.updated_by,
                            // updatedate: value.updated != null ? moment(value.updated, 'YYYY-MM-DD').format('MM/DD/YY') : null
                        });
                    }
                });

                if (results.length > 0) {
                    setInsuranceInfo(results);
                    setError(true)
                } else {
                    setError(false)
                }

            }
            else {
                toast.info("No Insurance Info found in this list");
            }
        }

        fetchInsuranceInfo();

        async function refreshInsuranceInfo() {
            fetchInsuranceInfo();
        }

        if (props.trigger > 0) {
            refreshInsuranceInfo();
        }
    }, [props.trigger]);

    const table = useAdvanceTable({
        data: insuranceinfo,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <div>
            <AdvanceTableProvider {...table}>
                <Col xs="4" className="mb-3 ms-auto">
                    <AdvanceTableSearchBox placeholder="Search..." />
                </Col>
                {error ? <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle text-center"
                    rowClassName="text-nowrap align-middle "//text-center
                    tableProps={{
                        size: 'lg',
                        striped: true,
                        className: 'fs-10 mb-0'
                    }}
                /> : <div className="d-flex justify-content-center align-items-center text-center" style={{ height: '50px' }}>
                    <p className="text-danger fw-bold mb-0">There is no data available in the table</p>
                </div>}
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </AdvanceTableProvider>
            {/* <InsuranceModal show={showModal} setShow={setShowModal} /> */}
        </div>
    );
};

export default InsuranceTable;

